import React, { useEffect, useState, useRef } from "react";
import { Image, Form, Select, Row, Col } from "antd";
import { ConsoleSqlOutlined, DownOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateImage, updateVoice } from "../../Redux/Slice/CasterSlice";
import { StyledText } from "../../Container/NewsList/styles";
import { HEYGEN_SPEAKERS, getSpeakerByLanguage, getVoiceIdByLanguage } from "../../utils";

const { Option } = Select;

const Avatar = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const vidconfig = useSelector((state: any) => state.caster.selectedConfig);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    localStorage.getItem("selectedLanguage") || "English"
  );
  const prevLanguageRef = useRef<string>(selectedLanguage);

  // Listen for language changes
  useEffect(() => {
    const handleStorageChange = () => {
      const storedLanguage = localStorage.getItem("selectedLanguage") || "English";
      const prevLanguage = prevLanguageRef.current;
      
      // If language changed and we have a selected avatar, update the voice_id
      if (prevLanguage !== storedLanguage && vidconfig?.image) {
        const speakerKey = Object.entries(HEYGEN_SPEAKERS).find(
          ([key, speaker]) => speaker.avatar_id === vidconfig.image
        )?.[0];
        
        if (speakerKey) {
          const newVoiceId = getVoiceIdByLanguage(speakerKey, storedLanguage);
          dispatch(updateVoice({ voice: newVoiceId }));
          form.setFieldsValue({ voice: newVoiceId });
        }
      }
      
      prevLanguageRef.current = storedLanguage;
      setSelectedLanguage(storedLanguage);
    };

    // Check on mount
    handleStorageChange();

    // Listen for storage events
    window.addEventListener("storage", handleStorageChange);
    
    // Also check periodically in case of same-tab updates
    const interval = setInterval(handleStorageChange, 100);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [vidconfig?.image, dispatch, form]);

  console.log(vidconfig);
  const handleAvatarSelect = (key: string) => {
    const speaker = getSpeakerByLanguage(key, selectedLanguage);
    if (!speaker) return;

    dispatch(updateImage({ image: speaker.avatar_id }));
    dispatch(updateVoice({ voice: speaker.voice_id }));

    form.setFieldsValue({
      image: speaker.avatar_id,
      voice: speaker.voice_id,
    });
  };

  const handleVoiceChange = (voiceId: string) => {
    // Find the speaker that matches this voice_id for the current language
    const entry = Object.entries(HEYGEN_SPEAKERS).find(([key, speaker]) => {
      const currentVoiceId = getVoiceIdByLanguage(key, selectedLanguage);
      return currentVoiceId === voiceId;
    });
    
    if (!entry) return;
    
    const [key, speaker] = entry;
    const languageAwareSpeaker = getSpeakerByLanguage(key, selectedLanguage);

    dispatch(updateImage({ image: languageAwareSpeaker.avatar_id }));
    dispatch(updateVoice({ voice: languageAwareSpeaker.voice_id }));

    form.setFieldsValue({
      image: languageAwareSpeaker.avatar_id,
      voice: languageAwareSpeaker.voice_id,
    });
  };

  useEffect(() => {
    if (vidconfig?.image && vidconfig?.voice) {
      form.setFieldsValue({
        image: vidconfig.image,
        voice: vidconfig.voice,
      });
    }
  }, []);

  return (
    <Row>
      <Col span={24}>
        <Form form={form}>
          <StyledText>
            <span style={{ color: "red" }}>*</span> Pick your Avatar
          </StyledText>

          <Form.Item name="image">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {Object.entries(HEYGEN_SPEAKERS).map(([key, speaker]) => (
                <button
                  key={speaker.avatar_id}
                  type="button"
                  onClick={() => handleAvatarSelect(key)}
                  style={{
                    border:
                      vidconfig?.image === speaker.avatar_id
                        ? "4px solid red"
                        : "2px solid transparent",
                    borderRadius: "6px",
                    padding: "2px",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                >
                  <Image
                    preview={false}
                    src={`${process.env.PUBLIC_URL}/${speaker.img}`}
                    width={100}
                    height={100}
                  />
                </button>
              ))}
            </div>
          </Form.Item>

          <StyledText>
            <span style={{ color: "red" }}>*</span> Select Speaker
          </StyledText>

          <Form.Item name="voice">
            <Select
              size="large"
              placeholder="Select Voice"
              suffixIcon={<DownOutlined />}
              onChange={handleVoiceChange}
            >
              {Object.entries(HEYGEN_SPEAKERS).map(([key, speaker]) => {
                const voiceId = getVoiceIdByLanguage(key, selectedLanguage);
                return (
                  <Option key={voiceId} value={voiceId}>
                    {speaker.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default Avatar;
